"use client";

import { useTranslations } from "next-intl";

import { useRelatedProjects } from "@/app/[locale]/projects/_api/use-project-queries";
import { ProjectTile } from "@/app/[locale]/projects/_components/project-tile";
import { HorizontalScrollRow } from "@/components/horizontal-scroll-row";
import { TileSection } from "@/components/sections/tile-section";
import { SCROLL_TILE_WIDTH } from "@/lib/constants";

export function RelatedProjects({ projectId }: { projectId: string }) {
  const t = useTranslations("projects");
  const { data } = useRelatedProjects(projectId);
  const projects = data?.content ?? [];

  if (projects.length === 0) return null;

  return (
    <TileSection
      title={t("detail.relatedProjects")}
      seeAllHref="/projects"
      seeAllLabel={t("detail.seeAllProjects")}
    >
      <HorizontalScrollRow>
        {projects.map((project) => (
          <div key={project.id} className={`shrink-0 ${SCROLL_TILE_WIDTH}`}>
            <ProjectTile project={project} />
          </div>
        ))}
      </HorizontalScrollRow>
    </TileSection>
  );
}
